import React from 'react';
import {Card, CardActions, CardContent, Fab, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './ActionPanel.css';
import {Button} from "../PageComponents/Button/Button";

function SampleHeader(props) {
    const {setOpen} = props;
    return (<CardActions>
        <Button clickHandler={(e) => setOpen(false)} size="small" text={"Close"} />
    </CardActions>)
}

function SampleBody(props) {
    const {} = props;
    return (
        <CardContent>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Word of the Day
            </Typography>
            <Typography variant="h5" component="div">
                Testing
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                adjective
            </Typography>
            <Typography variant="body2">
                well meaning and kindly.
                <br />
                {'"a benevolent smile"'}
            </Typography>
        </CardContent>
    )
}

export function ActionPanel (props) {
    const { Header = SampleHeader, Body = (<SampleBody/>) } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <div className="ActionPanel">
                <div className="actionButton">
                    <Fab color="secondary" sx={{color: "white"}} variant='outlined' size={"small"} aria-label="add" onClick={(e) => setOpen(true)}>
                        <AddIcon />
                    </Fab>
                </div>
                {(open) && (<>
                    <Card className="actionPane" variant="outlined" sx={{ backgroundColor: 'primary.dark' }}>
                        <Header setOpen={setOpen} />
                        <div style={{ marginLeft: '1rem', marginRight: '1rem'}}>
                            {Body}
                        </div>
                    </Card>
                </>)}
            </div>
        </>
    )
};

export function NavigationActionPanel (props) {
    const localProps = props;
    return (
        <>
            <div className="ActionPanel">
                <div className="actionButton">
                    <Fab color="secondary" sx={{color: "white"}} variant='outlined' size={"small"} aria-label="add" onClick={(e) => localProps.openCommand(true)}>
                        <AddIcon />
                    </Fab>
                </div>
            </div>
        </>
    )
};
